export const DELETE_LAST_DOCUMENT_CONFIRMATION = {
  title: 'Delete file?',
  message:
    'This is the last available version. Deleting it will also delete the file, ' +
    'and it will no longer be available for preview or download.',
};
